import styled from "styled-components"
import { Icon, Stack } from "./components"
import { NavigateOptions, useNavigate } from "react-router-dom";
import { useTranslation } from "./language";
import { IRegisterState, RegisterType } from "./models";

const StyledType = styled.div`
  cursor: pointer;
  min-height: 250px;
  width: 320px;
  text-align: center;
  border: 1px solid ${props => props.theme.main};
  border-radius: 5px;
  &:hover {
    background-color: ${props => props.theme.main};
		> div {
			> h1 {
				color: white;
			}
			> div {
				> svg {
					color: white;
				}
			}
		}
  }

  h1 {
    color: ${props => props.theme.main};
    font-size: 28px;
  }

  svg {
    color: ${props => props.theme.main};
  }
`;

const IconContainer = styled.div`
	height: 120px;
	margin-bottom: 20px;
	position: relative;
`;

export type TypeProps =
	{
		title: string;
		iconName: string;
		route: string;
		onClick(route: string, registerType: RegisterType): void;
		registerType: RegisterType
	};

const Type = ({ title, iconName, route, onClick, registerType }: TypeProps) => {
	return (
		<StyledType onClick={() => onClick(route, registerType)}>
			<Stack horizontalAlign="space-between" style={{ height: '100%' }}>
				<h1>{title}</h1>
				<IconContainer>
					<Icon size={120} name={iconName} />
				</IconContainer>
			</Stack>
		</StyledType>
	)
}

export const TypePicker = () => {

	const navigate = useNavigate();
	const translate = useTranslation();

	const onClick = (to: string, registerType: RegisterType) => {
		// If something else than navigation is to happen here, replace:
		const registerState: IRegisterState = {
			type: registerType,
		};

		const navOptions: NavigateOptions = {
			state: registerState
		};

		navigate(to, navOptions);
	}

	return (
		<Stack gap={20} horizontal horizontalAlign="center">
			{/* <Type title={translate("Welcome.Options.Doctor")} route="doctor" iconName="Doctor" onClick={onClick} registerType={RegisterType.Doctor} /> */}
			<Type title={translate("Welcome.Options.Reception")} route="reception" iconName="Reception" onClick={onClick} registerType={RegisterType.Reception} />
			<Type title={translate("Welcome.Options.PartnerAndHealthWorkers")} route="reception" iconName="Doctor" onClick={onClick} registerType={RegisterType.Partners} />
			{/* <Type title={translate("Welcome.Options.Vaccine")} route="reception" iconName="Syringe" onClick={onClick} registerType={RegisterType.Vaccine} /> */}

			{/* <Type title={translate("Welcome.Options.Lab")} route="reception" iconName="Syringe" onClick={onClick} registerType={RegisterType.Lab} /> */}

			{/* <Type title={translate("Welcome.Options.EmergencyRoom")} route="register" iconName="Doctor" onClick={onClick} registerType={RegisterType.EmergencyRoom} /> */}
			{/* <Type title={translate("Welcome.Options.Prescription")} route="prescription" iconName="PrescriptionBottle" onClick={onClick} registerType={RegisterType.Prescription} /> */}
			{/* <Type title={translate("Welcome.Options.Help")} route="help" iconName="Help" onClick={onClick} registerType={RegisterType.Help} /> */}
		</Stack>
	)
}